import type { SubscriptionAdminAction } from './actions';
import type { MigrationSummaryCounts, PlanFormState } from './types';

export type { SubscriptionAdminAction } from './actions';

export interface SubscriptionAdminState {
    error: string | null;
    selectedUserId: string | null;
    userSearchValue: string;
    selectedUserLabel: string | null;
    editingPlanId: string | null;
    planFormState: PlanFormState | null;
    planSaving: boolean;
    isCreating: boolean;
    lastMigrationSummary: MigrationSummaryCounts | null;
}

export function createInitialState(): SubscriptionAdminState {
    return {
        error: null,
        selectedUserId: null,
        userSearchValue: '',
        selectedUserLabel: null,
        editingPlanId: null,
        planFormState: null,
        planSaving: false,
        isCreating: false,
        lastMigrationSummary: null,
    };
}

export function reducer(state: SubscriptionAdminState, action: SubscriptionAdminAction): SubscriptionAdminState {
    switch (action.type) {
        case 'CLEAR_ERROR':
            return { ...state, error: null };

        case 'SET_ERROR':
            return { ...state, error: action.error };

        case 'SELECT_USER':
            return { ...state, selectedUserId: action.userId };

        case 'CLEAR_SELECTED_USER':
            return { ...state, selectedUserId: null };

        case 'SET_USER_SEARCH_VALUE':
            return { ...state, userSearchValue: action.value };

        case 'SET_SELECTED_USER_LABEL':
            return { ...state, selectedUserLabel: action.label };

        case 'START_EDITING_PLAN':
            return {
                ...state,
                editingPlanId: action.planId,
                planFormState: action.formState,
                planSaving: false,
                isCreating: false,
            };

        case 'STOP_EDITING_PLAN':
            return { ...state, editingPlanId: null, planFormState: null, planSaving: false, isCreating: false };

        case 'START_CREATING_PLAN':
            return {
                ...state,
                editingPlanId: null,
                planFormState: action.formState,
                planSaving: false,
                isCreating: true,
            };

        case 'UPDATE_PLAN_FORM_FIELD':
            if (!state.planFormState) return state;
            return { ...state, planFormState: { ...state.planFormState, [action.key]: action.value } };

        case 'SET_PLAN_SAVING':
            return { ...state, planSaving: action.saving };

        case 'SET_MIGRATION_SUMMARY':
            return { ...state, lastMigrationSummary: action.summary };

        default: {
            const _exhaustiveCheck: never = action;
            return state;
        }
    }
}
